import React, { useEffect, useRef } from 'react';

export default function InteractiveCursor() {
  const cursorDotRef = useRef(null);
  const cursorRingRef = useRef(null);
  const cursorGlowRef = useRef(null);

  useEffect(() => {
    const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (isTouch) return;

    let cx = window.innerWidth / 2;
    let cy = window.innerHeight / 2;
    let rx = cx;
    let ry = cy;
    let active = true;

    const handleMouseMove = (e) => {
      cx = e.clientX;
      cy = e.clientY;
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (!target) return;

      const isClickable =
        target.tagName === 'A' ||
        target.tagName === 'BUTTON' ||
        target.closest?.('a') ||
        target.closest?.('button') ||
        (target.classList && (
          target.classList.contains('filter-btn') ||
          target.classList.contains('srv-nav-item') ||
          target.classList.contains('social-icon') ||
          target.classList.contains('video-thumb') ||
          target.classList.contains('faq-q') ||
          target.closest?.('.faq-q')
        )) ||
        target.closest?.('.play-btn') ||
        target.closest?.('.card');

      if (cursorDotRef.current && cursorRingRef.current) {
        if (isClickable) {
          cursorDotRef.current.style.width = '6px';
          cursorDotRef.current.style.height = '6px';
          cursorRingRef.current.style.width = '20px';
          cursorRingRef.current.style.height = '20px';
          cursorRingRef.current.style.borderColor = 'var(--gold-br)';
        } else {
          cursorDotRef.current.style.width = '6px';
          cursorDotRef.current.style.height = '6px';
          cursorRingRef.current.style.width = '24px';
          cursorRingRef.current.style.height = '24px';
          cursorRingRef.current.style.borderColor = 'rgba(104,210,239,0.5)';
        }
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);

    const animateCursor = () => {
      if (!active) return;

      if (cursorDotRef.current) {
        cursorDotRef.current.style.left = `${cx}px`;
        cursorDotRef.current.style.top = `${cy}px`;
      }

      rx += (cx - rx) * 0.15;
      ry += (cy - ry) * 0.15;
      if (cursorRingRef.current) {
        cursorRingRef.current.style.left = `${rx}px`;
        cursorRingRef.current.style.top = `${ry}px`;
      }

      if (cursorGlowRef.current) {
        cursorGlowRef.current.style.left = `${cx}px`;
        cursorGlowRef.current.style.top = `${cy}px`;
      }

      requestAnimationFrame(animateCursor);
    };

    const animId = requestAnimationFrame(animateCursor);

    return () => {
      active = false;
      cancelAnimationFrame(animId);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) return null;

  return (
    <>
      <div id="cursor" ref={cursorDotRef} />
      <div id="cursor-ring" ref={cursorRingRef} />
      <div className="cursor-glow" ref={cursorGlowRef} />
    </>
  );
}
